module.exports = __webpack_public_path__ + "static/media/AR.574103e3.svg";